import { ApiClientError } from "../lib/api";

interface ErrorStateProps {
  error: unknown;
  onRetry?: () => void;
}

export default function ErrorState({ error, onRetry }: ErrorStateProps) {
  const isReauth =
    error instanceof ApiClientError && error.code === "reauth_required";
  const message =
    error instanceof Error ? error.message : "Something went wrong.";
  const reconnectUrl =
    error instanceof ApiClientError && error.reconnectUrl
      ? error.reconnectUrl
      : "/api/auth/start";

  return (
    <div className="card animate-fade-in p-6">
      <div className="flex items-start gap-3">
        <span
          aria-hidden="true"
          className="mt-0.5 inline-flex h-7 w-7 flex-none items-center justify-center rounded-full bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300"
        >
          !
        </span>
        <div className="flex-1">
          <h2 className="text-base font-semibold">
            {isReauth ? "Reconnect Google" : "Couldn't load your data"}
          </h2>
          <p className="mt-1 text-sm text-zinc-500">
            {isReauth
              ? "Your Google connection expired or was revoked. Reconnect to refresh your dashboard."
              : message}
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            {isReauth ? (
              <a href={reconnectUrl} className="btn-primary">
                Reconnect Google
              </a>
            ) : (
              onRetry && (
                <button type="button" onClick={onRetry} className="btn-primary">
                  Try again
                </button>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
